import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { authFetch } from './authFetch';

export interface DatasetReleaseDetails {
  releaseId: string;
  releaseName: string;
}

/**
 * `EpiArtifactExecution.datasetReleaseId` carries the session's active-dataset
 * fqn (`DATABASE.SCHEMA_NAME`, e.g. `EXPORT.RELEASE_X`), but `/dataset-releases/{id}`
 * matches on the catalog's short `DATASET` name — the schema segment. Strip the
 * database prefix before calling.
 */
export const useDatasetReleaseDetailsQuery = (
  datasetReleaseId: string,
  enabled = true
): UseQueryResult<{ data: DatasetReleaseDetails }> => {
  return useQuery({
    queryKey: ['dataset-releases', datasetReleaseId],
    queryFn: () =>
      authFetch<{ data: DatasetReleaseDetails }>(
        `/dataset-releases/${encodeURIComponent(datasetReleaseId)}`
      ),
    enabled: enabled && !!datasetReleaseId,
    staleTime: 5 * 60 * 1000,
  });
};
